import { render, staticRenderFns } from "./ProspectContact.vue?vue&type=template&id=24891182"
import script from "./ProspectContact.vue?vue&type=script&lang=ts"
export * from "./ProspectContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports